import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-status-tag',
    templateUrl: './status-tag.component.html',
    styleUrls: ['./status-tag.component.less']
})
export class StatusTagComponent implements OnInit {
    @Input() status = '';
    @Input() tagColor!: string;
    @Input() showDown = false;

    constructor() {
    }

    statusDict: {
        [propName: string]: {
            label: string;
            color: string;
        }
    } = {
        START_FAILED: {
            label: 'Start Failed',
            color: 'red',
        },
        STARTING: {
            label: 'Starting',
            color: 'blue',
        },
        RUNNING: {
            label: 'Running',
            color: 'green',
        },
        STOPPING: {
            label: 'Stopping',
            color: 'blue',
        },
        STOPPED: {
            label: 'Stopped',
            color: 'red',
        },
        ONLINE: {
            label: 'Online',
            color: 'green',
        },
        OFFLINE: {
            label: 'Offline',
            color: 'red',
        },
        ABORT: {
            label: 'Abort',
            color: 'volcano',
        },
        SUCCESS: {
            label: 'Success',
            color: 'cyan',
        },
        0: {
            label: 'Success',
            color: 'green',
        },
        '-1': {
            label: 'Failure',
            color: 'orange',
        },
        '-2': {
            label: 'Reject',
            color: 'red',
        },
        CREATED: {
            label: 'Created',
            color: 'green',
        },
        ON_GOING: {
            label: 'On-going',
            color: 'blue'
        },
        IDLE: {
            label: 'IDLE',
            color: 'orange'
        },
        FINISHED: {
            label: 'Finished',
            color: 'gray'
        },
        DRAFT: {
            label: 'Draft',
            color: 'gray'
        },
        ARCHIVED: {
            label: 'Archived',
            color: 'red'
        },
        ACTIVE: {
            label: 'Planned',
            color: 'green',
        },
        INPROGRESS: {
            label: 'In Progress',
            color: 'blue'
        },
        COMPLETED: {
            label: 'Completed',
            color: '#87d068'
        },
        CANCELLED: {
            label: 'Cancelled',
            color: 'orange'
        },
        PENDING: {
            label: 'Pending',
            color: 'green'
        },
        PLANNED: {
            label: 'Planned',
            color: 'green',
        },
        IN_PROGRESS: {
            label: 'In Progress',
            color: 'blue'
        },
        DONE: {
            label: 'Done',
            color: 'cyan'
        },
        OVERDUE: {
            label: 'Overdue',
            color: 'orange'
        },
        Overdue: {
            label: 'Overdue',
            color: 'orange'
        },
        CRITICAL: {
            label: 'Critical',
            color: '#FF0000',
        },
        HIGH: {
            label: 'High',
            color: '#ED9121',
        },
        MEDIUM: {
            label: 'Medium',
            color: '#00B140',
        },
        LOW: {
            label: 'Low',
            color: '#808080',
        },
        CLOSED: {
            label: 'Closed',
            color: '#808080',
        },
        WEEKLY: {
            label: 'Weekly',
            color: 'orange',
        },
        PAUSED: {
            label: 'Paused',
            color: 'red'
        },
        APPROVE: {
            label: 'Approved',
            color: '#87d068'
        },
        REJECT: {
            label: 'Rejected',
            color: 'red'
        },
        // test case status
        NOT_STARTED: {
            label: 'Not Started',
            color: 'gray'
        },
        PASSED: {
            label: 'Passed',
            color: 'green'
        },
        FAILED: {
            label: 'Failed',
            color: 'red'
        },
        ONGOING: {
            label: 'Ongoing',
            color: 'blue'
        },
        NOT_APPLICABLE: {
            label: 'N/A',
            color: 'orange'
        },
        MAJOR: {
            label: 'Major',
            color: '#ED9121'
        },
        MINOR: {
            label: 'Minor',
            color: '#808080',
        },
        UP: {
            label: 'Up',
            color: '#87d068',
        },
        DOWN: {
            label: 'Down',
            color: '#FF0000',
        },
        PUBLISHED: {
            label: 'Published',
            color: '#87d068',
        }
    };

    ngOnInit(): void {
    }

    getStatusLabel(status: string|number): string|number {
        if (!status && status !== 0) {
            return '';
        }
        return this.statusDict[(typeof status === 'string') ? status.toUpperCase() : status]?.label || status;
    }

    getStatusColor(status: string|number): string {
        if (!status && status !== 0) {
            return '';
        }
        return this.statusDict[(typeof status === 'string') ? status.toUpperCase() : status]?.color || '';
    }

}
